<template>
  <!-- 点击修改的弹出框 start -->
  <el-dialog title="修改委托单信息" class="dialog-container" :visible.sync="order_show" :before-close="handleClose">
    <el-form class="form-container" :model="order_info">
      <el-form-item label="委托单号" class="input-list">
        <p class="input-txt">{{order_info.lab_order_id}}</p>
      </el-form-item>
      <!-- 业务人员 
      <el-form-item
        class="input-list"
        label="业务人员"
        v-if="user_type == 5 && (user_id == order_info.lab_user_id || order_info.lab_user_id == 0)"
      >
        <el-select
          class="options-select"
          v-model="order_info.lab_sales_id"
          value-key="user_id"
          placeholder="请选择业务人员"
          clearable
        >
          <el-option
            v-for="item in sales"
            :key="item.user_id"
            :label="item.name"
            :value="item.user_id"
          ></el-option>
        </el-select>
      </el-form-item>
      -->
      <el-form-item class="input-list input-top" label="备注">
        <el-input class="txt-area" type="textarea" v-model="order_info.memo" placeholder="请输入备注"></el-input>
      </el-form-item>
      <el-form-item class="btn-list">
        <el-button class="btn-save" @click="updateOrder(order_info)">保存</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
  <!-- 点击修改 出现的弹窗框 end -->
</template>

<script>
import { getStore, getCookie } from "common/js/mUtils";

export default {
  props: [
    'order_show',
    'sales',
    'order_info'
  ],
  data() {
    return {
      user_type: 0,
      user_id: 0
    };
  },
  computed: {
  },
  watch: {
  },
  created() {
    this.user_type = getStore("user_type");
    this.user_id = getCookie("u_uuid_userId");
  },
  methods: {
    handleClose() {
      this.$emit('before-close')
    },
    updateOrder(order_info) {
      let that = this;
      this.$api
        .updateOrderInfo({
          type: order_info.type,
          order_id: order_info.lab_order_id,
          lab_sales_id: order_info.lab_sales_id,
          memo: order_info.memo
        })
        .then(res => {
          if (res.data.msg === true) {
            that.$message({
              message: "委托单信息更新成功。",
              type: "success",
              customClass: "msg-position",
              showClose: true
            });
            that.$emit("updated", false);
          } else {
            that.$message({
              message: res.data.error,
              type: "error",
              customClass: "msg-position",
              showClose: true
            });
          }
        })
        .catch(e => {
          that.$message({
            message: `${e}`,
            type: "error",
            customClass: "msg-position",
            showClose: true
          });
        });
    }
  }
};
</script>

<style lang='stylus' rel='stylesheet/stylus'>
@import '~common/stylus/box.styl';
</style>
